import { getApiErrorStatus } from '../../../helpers/apiErrorHelper';

// Read only the public error payload; never display raw server exceptions,
// request headers, survey responses, or credentials to the shopper.
const hasErrorCode = (value: unknown, code: string, depth = 0): boolean => {
  if (depth > 4 || value == null) return false;
  if (typeof value === 'string') return value.includes(code);
  if (typeof value !== 'object') return false;
  return ['code', 'message', 'title', 'detail', 'response', 'result', 'data'].some((key) =>
    hasErrorCode((value as Record<string, unknown>)[key], code, depth + 1));
};

export const isSurveyCheckInRequired = (error: unknown) => hasErrorCode(error, 'geolocation_check_in_required');

export const isSurveyOfflineError = (error: any): boolean =>
  !getApiErrorStatus(error) && (
    error?.code === 'ERR_NETWORK' || error?.code === 'ECONNABORTED' || error?.code === 'ETIMEDOUT'
    || error?.message === 'Network Error' || error?.message === 'Request timed out'
    || error?.message === 'Failed to fetch'
  );

export const getSurveyLoadErrorKey = (error: unknown): string | undefined => {
  if (!error) return undefined;
  const status = getApiErrorStatus(error);
  if (status === 401 || status === 498) return 'survey-load-auth-error';
  if (status === 403 || status === 423) return 'survey-load-forbidden';
  if (hasErrorCode(error, 'survey_not_configured')) return 'survey-load-not-configured';
  if (isSurveyCheckInRequired(error)) return 'mission.survey-load-geolocation-check-in-required';
  if (status === 409) return 'mission.survey-load-not-editable';
  if (status === 400 || status === 404) return 'mission.survey-load-blocked-generic';
  if (isSurveyOfflineError(error)) return 'survey-load-network-error';
  return 'survey-load-failed';
};
